import {
  DemoUrlDisplay,
  SettingMainItemsKeys,
  type SettingsStateType,
  SettingsSubKeys,
} from '@carboncopyco/types/desktop/appSettings';

export const settingInitData: SettingsStateType = {
  [SettingMainItemsKeys.BrowserSettings]: {
    [SettingsSubKeys.BrowserAddress]: 'https://www.google.com',
  },
  [SettingMainItemsKeys.AppConfiguration]: {
    [SettingsSubKeys.TabCaching]: 50,
    [SettingsSubKeys.PersistentStorageToggleState]: true,
  },
  [SettingMainItemsKeys.PresentationDisplay]: {
    [SettingsSubKeys.ShowSpeakerPanelByDefault]: false,
    [SettingsSubKeys.DemoUrlDisplay]: DemoUrlDisplay.only_domain,
  },
  [SettingMainItemsKeys.MouseAnimation]: {
    [SettingsSubKeys.MouseAnimationToggleState]: true,
    [SettingsSubKeys.MouseAnimationSpeed]: -500,
    [SettingsSubKeys.MouseAnimationSize]: 41,
    [SettingsSubKeys.MouseAnimationColor]: '#0078EF',
  },
};
